export const DISABLED_ADMIN_FEATURES_MESSAGE = "In impersonate mode admin page features are disabled";
